import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles<{ singleImage: boolean }>()(
  (theme, { singleImage }) => ({
    container: {
      position: "relative",
      background: singleImage ? "transparent" : "#ececec",
      display: "inline-block",
    },
    controls: {
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      alignItems: "center",
      gap: theme.spacing(2),
      top: theme.spacing(2),
      right: theme.spacing(2),
      zIndex: 2,
      [theme.breakpoints.down("md")]: {
        top: theme.spacing(1),
        right: theme.spacing(1),
        flexWrap: "wrap-reverse",
        maxHeight: "100%",
      },
    },
    image: {
      position: "relative",
      objectFit: "contain",
      cursor: "pointer",
      width: "auto",
      height: "auto",
      maxWidth: singleImage ? 605 : 300,
      maxHeight: singleImage ? "600px" : "300px",
      [theme.breakpoints.down("lg")]: {
        width: "100%",
        maxWidth: "100%",
        maxHeight: singleImage ? "400px" : "200px",
      },
      [theme.breakpoints.down("md")]: {
        maxWidth: "100%",
      },
    },
    editIcon: {
      color: "#ffffff",
      cursor: "pointer",
      filter: `drop-shadow(0px 0px 1px ${theme.palette.primary.main})`,
      transition: "background-color 0.1s, transform 0.1s",
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
    placeholderContainer: {
      position: "relative",
      display: "inline-block",
      [theme.breakpoints.down("lg")]: {
        width: "calc(50vw - 20px)",
        minHeight: "calc(50vw - 20px)",
      },
    },
    imagePlaceholder: {
      display: "grid",
      placeItems: "center",
      width: singleImage ? 605 : 300,
      height: singleImage ? "600px" : "300px",
      backgroundColor: "#5b6467",
      backgroundImage: "linear-gradient(315deg, #5b6467 0%, #8b939a 74%)",
      cursor: "pointer",
      [theme.breakpoints.down("lg")]: {
        width: "100%",
        height: "100%",
      },
    },
    lockIcon: {
      width: 60,
      height: 60,
      color: "#ececec",
    },
    lockedImageWrapper: {
      position: "relative",
      width: singleImage ? 605 : 300,
      height: singleImage ? "600px" : "300px",
      overflow: "hidden",
      cursor: "pointer",
      [theme.breakpoints.down("lg")]: {
        width: "calc(50vw - 20px)",
        height: "calc(50vw - 20px)",
        maxHeight: singleImage ? "400px" : "200px",
      },
    },
    blurredBackgroundImage: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundSize: "cover",
      backgroundPosition: "center",
      filter: "blur(1rem)",
      WebkitFilter: "blur(1rem)",
    },
  })
);
